export const SET_TOKEN = "SET_TOKEN";

export interface ITokenAction {
    type: typeof SET_TOKEN,
    token: string
}

export const setToken = (token : string):ITokenAction => {
    return {
        type: SET_TOKEN,
        token
    };
}


